import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import AppContent from '../../../_Shared/Layout/AppContent';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    table: {
        minWidth: 700
    }
});

class Settings extends React.Component {

    constructor(props) {
        super(props);
    }

    handleInputChange = (name, value) => {
        this.props.onEditSettings(name, value);
    }

    render() {
        const { query } = this.props;

        return (<AppContent>
                    <Grid container spacing={24}>
                        <Grid container item xs={5}>
                            <Grid item lg={12} xl={12}>
                                <TextField autoFocus value={query.settings.name} onChange={e => this.handleInputChange('name', e.target.value)} 
                                    id="name" name="name" label="Name" type="text" fullWidth />
                            </Grid>
                        </Grid>
                        <Grid container item xs={7}></Grid>
                        {/* <Grid container item xs={5} justify="space-between">
                            <Grid item lg={10} xl={10}>
                                <TextField value={query.settings.connectionEndpointId} onChange={e => this.handleInputChange('connectionEndpointId', e.target.value)} 
                                    id="connectionEndpointId" name="connectionEndpointId" label="Connection Endpoint" type="text" fullWidth />
                            </Grid>
                            <Grid item lg={1} xl={1}>
                                <Button variant="fab" mini color="primary" aria-label="Add" className={classes.button}>
                                    <AddIcon />
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid container item xs={7}></Grid>
                        <Grid container item xs={5} justify="space-between">
                            <Grid item lg={2} xl={2}>
                                <FormControl component="fieldset">
                                    <FormLabel component="legend">Table Is Query</FormLabel>
                                    <FormGroup>
                                        <FormControlLabel control={
                                            <Switch checked={query.settings.tableIsQuery}
                                                onChange={e => this.handleInputChange('tableIsQuery', e.target.checked)}
                                                value='tableIsQuery'
                                            />}
                                        />
                                    </FormGroup>
                                </FormControl>
                            </Grid>
                            <Grid item lg={8} xl={8}>
                                <TextField value={query.settings.tableId} onChange={e => this.handleInputChange('tableId', e.target.value)} 
                                    id="tableId" name="tableId" label="Table Id" type="text" fullWidth />
                            </Grid>
                            <Grid item lg={1} xl={1}>
                                <Button variant="fab" mini color="primary" aria-label="Edit" disabled={!query.settings.tableIsQuery} className={classes.button}>
                                    <EditIcon />
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid container item xs={7}></Grid> */}
                        <Grid container item xs={5}>
                            <Grid item lg={12} xl={12}>
                                <TextField value={query.settings.tableId} onChange={e => this.handleInputChange('tableId', e.target.value)} 
                                    id="tableId" name="tableId" label="Table Id" type="text" fullWidth />
                            </Grid>
                        </Grid>
                        <Grid container item xs={7}></Grid>
                        <Grid container item xs={5} justify="space-between">
                            <Grid item lg={2} xl={2}>
                                <FormControl component="fieldset">
                                    <FormLabel component="legend">Compressed</FormLabel>
                                    <FormGroup>
                                        <FormControlLabel control={
                                            <Switch checked={query.settings.compressed}
                                                onChange={e => this.handleInputChange('compressed', e.target.checked)}
                                                value='compressed'
                                            />}
                                        />
                                    </FormGroup>
                                </FormControl>
                            </Grid>
                            <Grid item lg={2} xl={2}>
                                <FormControl component="fieldset">
                                    <FormLabel component="legend">Manifest</FormLabel>
                                    <FormGroup>
                                        <FormControlLabel control={
                                            <Switch checked={query.settings.manifest}
                                                onChange={e => this.handleInputChange('manifest', e.target.checked)}
                                                value='manifest'
                                            />}
                                        />
                                    </FormGroup>
                                </FormControl>
                            </Grid>
                            <Grid item lg={2} xl={2}>
                                <FormControl component="fieldset">
                                    <FormLabel component="legend">Escape Delimiter</FormLabel>
                                    <FormGroup>
                                        <FormControlLabel control={
                                            <Switch checked={query.settings.escapeDelimiter}
                                                onChange={e => this.handleInputChange('escapeDelimiter', e.target.checked)}
                                                value='escapeDelimiter'
                                            />}
                                        />
                                    </FormGroup>
                                </FormControl>
                            </Grid>
                            <Grid item lg={2} xl={2}>
                                <FormControl component="fieldset">
                                    <FormLabel component="legend">Csv File</FormLabel>
                                    <FormGroup>
                                        <FormControlLabel control={
                                            <Switch checked={query.settings.csvFile}
                                                onChange={e => this.handleInputChange('csvFile', e.target.checked)}
                                                value='csvFile'
                                            />}
                                        />
                                    </FormGroup>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid container item xs={7}></Grid>
                        <Grid container item xs={5} justify="space-between">
                            <Grid item lg={5} xl={5}>
                                <TextField value={query.settings.delimiter} onChange={e => this.handleInputChange('delimiter', e.target.value)} 
                                    id="delimiter" name="delimiter" label="Delimiter" type="text" fullWidth />
                            </Grid>
                            <Grid item lg={5} xl={5}>
                                <TextField value={query.settings.ignoreHeaderRows} onChange={e => this.handleInputChange('ignoreHeaderRows', e.target.value)} 
                                    id="ignoreHeaderRows" name="ignoreHeaderRows" label="Ignore Header Rows" type="number" fullWidth />
                            </Grid>
                        </Grid>
                        <Grid container item xs={7}></Grid>
                        <Grid container item xs={5}>
                            <Grid item lg={2} xl={2}>
                                <FormControl component="fieldset">
                                    <FormLabel component="legend">Copy Only</FormLabel>
                                    <FormGroup>
                                        <FormControlLabel control={
                                            <Switch checked={query.settings.copyOnly}
                                                onChange={e => this.handleInputChange('copyOnly', e.target.checked)}
                                                value='copyOnly'
                                            />}
                                        />
                                    </FormGroup>
                                </FormControl>
                            </Grid>
                            <Grid item lg={10} xl={10}>
                                <TextField value={query.settings.copyFormatRegex} onChange={e => this.handleInputChange('copyFormatRegex', e.target.value)} 
                                    id="copyFormatRegex" name="copyFormatRegex" label="Copy Format Regex" type="text" fullWidth />
                            </Grid>
                        </Grid>
                        <Grid container item xs={7}></Grid>
                    </Grid>
                </AppContent>)
    }
}

Settings.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Settings);


// WEBPACK FOOTER //
// ./src/Components/Presentation/ETL/QueryEditors/DataLoadTabs/Settings.js